/* Patagonia Café — Harmonisation design (14-10-2026).
   1. Applique la charte au configurateur d'abonnement, rendu dans un shadow DOM que les feuilles de style de la page n'atteignent pas.
   2. Nos cafés : un seul H1 par page (le titre du parcours mobile devient un h2, même rendu).
   3. Notre histoire : boutons d'action sous le bandeau d'ouverture s'ils manquent. */
(() => {
  'use strict';
  document.documentElement.classList.add('pch-ready');

  /* 2. Un seul H1 */
  document.querySelectorAll('.pcm-hero h1').forEach(h => {
    const h2 = document.createElement('h2');
    h2.className = (h.className + ' pcm-hero-title').trim();
    h2.innerHTML = h.innerHTML;
    h.replaceWith(h2);
  });

  /* 3. CTA du bandeau Notre histoire */
  const heroText = document.querySelector('.pc-page-notre-histoire.pc-hero .pc-hero-text');
  if (heroText && !heroText.querySelector('.pc-hero-actions')) {
    const actions = document.createElement('div');
    actions.className = 'pc-hero-actions';
    const primary = document.createElement('a');
    primary.className = 'pc-btn pc-btn-primary';
    primary.href = '/pages/nos-cafes';
    primary.textContent = 'Découvrir nos cafés';
    const secondary = document.createElement('a');
    secondary.className = 'pc-btn pc-btn-secondary';
    secondary.href = '/products/pack-decouverte';
    secondary.textContent = 'Le pack découverte';
    actions.append(primary, secondary);
    heroText.appendChild(actions);
  }

  /* 4. Mobile : le suivi du café préféré peut être replié après la dégustation. */
  const media = window.matchMedia('(max-width: 749px)');
  const folds = new Map();
  const foldTargets = [
    ['.pc-mix__followup-grid', 'Vous avez goûté ? Retrouver votre préféré']
  ];
  const fold = (node, label) => {
    if (!node || folds.has(node) || node.closest('.pc-mobile-disclosure')) return;
    if (!node.getClientRects().length) return; /* bloc masqué sur cette page : rien à replier */
    const marker = document.createComment('pc-harmonie-position');
    const details = document.createElement('details');
    details.className = 'pc-mobile-disclosure pc-harmonie-fold';
    const summary = document.createElement('summary');
    summary.textContent = label;
    const body = document.createElement('div');
    body.className = 'pc-mobile-disclosure__body';
    node.before(marker, details);
    details.append(summary, body);
    body.append(node);
    folds.set(node, { marker, details });
  };
  const applyFolds = () => {
    if (!media.matches) {
      folds.forEach(({ marker, details }, node) => { marker.replaceWith(node); details.remove(); });
      folds.clear();
      return;
    }
    foldTargets.forEach(([selector, label]) => {
      let nodes = [];
      try { nodes = [...document.querySelectorAll(selector)]; } catch (error) { nodes = []; }
      nodes.forEach(node => fold(node, label));
    });
    const hash = location.hash;
    if (hash) {
      let target = null;
      try { target = document.getElementById(decodeURIComponent(hash.slice(1))); } catch (error) { target = null; }
      let details = target && target.closest('.pc-harmonie-fold');
      while (details) { details.open = true; details = details.parentElement.closest('.pc-mobile-disclosure'); }
    }
  };
  media.addEventListener('change', applyFolds);
  window.addEventListener('hashchange', applyFolds);
  document.addEventListener('click', event => {
    if (!media.matches || !(event.target instanceof Element)) return;
    const link = event.target.closest('a[href^="#"]');
    if (!link) return;
    let target = null;
    try { target = document.getElementById(decodeURIComponent(link.getAttribute('href').slice(1))); } catch (error) { target = null; }
    let details = target && target.closest('.pc-harmonie-fold');
    while (details) { details.open = true; details = details.parentElement.closest('.pc-mobile-disclosure'); }
  }, true);
  applyFolds();

  /* 1. Configurateur d'abonnement */
  const root = document.getElementById('pc-abonnement-root');
  const script = document.currentScript;
  const href = script && script.dataset ? script.dataset.abonnementCss : '';
  if (!root || !href) return;
  const inject = () => {
    const shadow = root.shadowRoot;
    if (!shadow) return;
    if (shadow.querySelector('link[data-pch-harmonie]')) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.setAttribute('data-pch-harmonie', '1');
    shadow.appendChild(link);
    /* Légende de la photo : « fraîchement torréfiés », jamais « à la demande » */
    shadow.querySelectorAll('.pc-box-visual figcaption').forEach(caption => {
      if (/à la demande/i.test(caption.textContent)) caption.textContent = 'Vos 4 cafés au choix, fraîchement torréfiés';
    });
  };
  inject();
  let ticks = 0;
  const timer = setInterval(() => {
    inject();
    ticks += 1;
    if (ticks > 240) clearInterval(timer);
  }, 250);
  document.addEventListener('shopify:section:load', inject);
})();
